module.exports = __webpack_public_path__ + "img/HP_00_mono_AE_00003.8d73c857.png";